import { playAvatarAudio } from '../../../common/avatar/avatarActions';
import { narrateStart } from '../../../common/audio/audioActions';
import { blockScreen, unblockScreen, activateNextButton } from '../../../common/screen/screenActions';

export const narrateOpeningScreen = (instruction) => async (dispatch) => {
    dispatch(blockScreen());
    dispatch(narrateStart());
    await dispatch(playAvatarAudio(instruction));
    dispatch(activateNextButton());
    dispatch(unblockScreen());
};

export default narrateOpeningScreen;
